export function SEARCH_SELLER(state, data) {
  state.search = data;
}
export function SET_CLIENT(state, data) {
  state.client = data;
}

export function SET_CHANGE_DISTRIBUTOR(state, item) {
  state.changeDistributor = item;
}

export function FETCH_CLIENTS(state, item) {
  state.fetchClients = item;
}
